import { filterNonNullValues } from '@/lib/utils'
import Clients from '@/views/clients'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/clients/')({
    component: Clients,
    validateSearch: (search) => filterNonNullValues({
        page: search.page ? Number(search.page) : 0,
        page_size: search.page_size ? Number(search.page_size) : 10,
        ordering: typeof search.ordering === 'string' ? search.ordering : null,
        name: typeof search.name === 'string' ? search.name : null,
    }),
})
